import React from 'react';
import { CTASection } from '../../components/CTASection';
import { Printer, CheckCircle, Palette, Users, Zap, Award } from 'lucide-react';
export function ScreenPrinting() {
  const benefits = [{
    icon: <Palette className="w-6 h-6" data-id="element-1899" />,
    title: 'Vibrant, Long-Lasting Colors',
    description: 'Premium inks that stay bold wash after wash'
  }, {
    icon: <Zap className="w-6 h-6" data-id="element-1900" />,
    title: 'Cost-Effective for Bulk Orders',
    description: 'Perfect for teams, events, and large campaigns'
  }, {
    icon: <Award className="w-6 h-6" data-id="element-1901" />,
    title: 'Professional Quality',
    description: 'Industry-leading equipment and expertise'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-1902" />,
    title: 'Perfect for Any Group',
    description: 'Schools, businesses, sports teams, and events'
  }];
  const features = ['High-volume production capability', 'Pantone color matching', 'Multiple print locations (front, back, sleeves)', 'Specialty inks (metallic, glow-in-the-dark, puff)', 'Fast turnaround times', 'In-house art department'];
  return <div className="flex flex-col w-full" data-id="element-1903">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-1904">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1905">
          <div className="flex justify-center mb-6" data-id="element-1906">
            <Printer className="w-16 h-16 text-white" data-id="element-1907" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1908">
            Screen Printing
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-1909">
            Bold, vibrant designs that make a lasting impression. From small
            batches to large-scale production, we deliver exceptional quality
            every time.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-id="element-1910">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1911">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-1912">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1913">
              The Gold Standard in Custom Apparel
            </h2>
            <div className="prose prose-lg max-w-none text-gray-700 space-y-4" data-id="element-1914">
              <p data-id="element-1915">
                Screen printing is the time-tested method for creating bold,
                durable designs on apparel. Whether you're outfitting a sports
                team, promoting your business, or creating merchandise for an
                event, screen printing delivers unmatched vibrancy and longevity
                that stands up to repeated wear and washing.
              </p>
              <p data-id="element-1916">
                At Wear Haus Designs, we've perfected the art of screen printing
                with state-of-the-art equipment and decades of expertise. Our
                process ensures crisp lines, vibrant colors, and professional
                results that exceed expectations—every single time.
              </p>
            </div>
          </div>

          {/* Work Gallery */}
          <div className="mb-16" data-id="element-1917">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1918">
              <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-1919">
                <img src="https://cdn.magicpatterns.com/uploads/uJ284ZpPSRrQqggPC1MSL8/Screen-Printing1.png" alt="Screen printing example - Benton Bobcats Elementary school shirt" className="w-full h-64 object-cover" data-id="element-1920" />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-1921">
                <img src="https://cdn.magicpatterns.com/uploads/ugJbzxw1oXqwLBx8VsiKvY/Screen-Printing2.png" alt="Screen printing example - Fight Club Nehemiah custom design" className="w-full h-64 object-cover" data-id="element-1922" />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-1923">
                <img src="https://cdn.magicpatterns.com/uploads/33CttEmKLy19WspZLM85CU/Screen-Printing3.png" alt="Screen printing example - Cherry Pickers vintage style shirt" className="w-full h-64 object-cover" data-id="element-1924" />
              </div>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-1925">
            {benefits.map((benefit, index) => <div key={index} className="bg-gray-50 rounded-xl p-8 border border-gray-100" data-id="element-1926">
                <div className="flex items-start gap-4" data-id="element-1927">
                  <div className="flex-shrink-0 w-12 h-12 bg-wh-pink rounded-lg flex items-center justify-center text-white" data-id="element-1928">
                    {benefit.icon}
                  </div>
                  <div data-id="element-1929">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1930">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-1931">{benefit.description}</p>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Video Section */}
          <div className="mb-16" data-id="element-1932">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-1933">
              See Our Screen Printing Process in Action
            </h2>
            <div className="max-w-4xl mx-auto" data-id="element-1934">
              <div className="relative w-full" style={{
              paddingBottom: '56.25%'
            }} data-id="element-1935">
                <iframe className="absolute top-0 left-0 w-full h-full rounded-2xl shadow-2xl" src="https://www.youtube.com/embed/t0OMEg2_rPM" title="Screen Printing Process" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-1936"></iframe>
              </div>
            </div>
          </div>

          {/* Features List */}
          <div className="bg-gradient-to-br from-wh-teal to-teal-600 rounded-2xl p-12 text-white" data-id="element-1937">
            <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-1938">
              What We Offer
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-1939">
              {features.map((feature, index) => <div key={index} className="flex items-center gap-3" data-id="element-1940">
                  <CheckCircle className="w-6 h-6 text-wh-yellow flex-shrink-0" data-id="element-1941" />
                  <span className="text-lg" data-id="element-1942">{feature}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50" data-id="element-1943">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1944">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-1945">
            Screen Printing FAQs
          </h2>

          <div className="space-y-6" data-id="element-1946">
            <div className="bg-white rounded-xl p-8 border border-gray-100" data-id="element-1947">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1948">
                What's the minimum order quantity?
              </h3>
              <p className="text-gray-700" data-id="element-1949">
                We can accommodate orders of all sizes, but screen printing
                becomes most cost-effective for orders of 12 or more pieces.
                Contact us to discuss your specific needs.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 border border-gray-100" data-id="element-1950">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1951">
                How long does screen printing take?
              </h3>
              <p className="text-gray-700" data-id="element-1952">
                Typical turnaround is 7-10 business days from art approval. Rush
                services are available for time-sensitive projects—just ask!
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 border border-gray-100" data-id="element-1953">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1954">
                What materials can you print on?
              </h3>
              <p className="text-gray-700" data-id="element-1955">
                We can screen print on cotton, polyester, blends, and specialty
                fabrics. We work with t-shirts, hoodies, sweatshirts, bags, and
                more.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 border border-gray-100" data-id="element-1956">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1957">
                Do you help with design?
              </h3>
              <p className="text-gray-700" data-id="element-1958">
                Absolutely! Our in-house art department can help bring your
                vision to life or refine existing artwork to ensure the best
                print quality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection data-id="element-1959" />
    </div>;
}